import startShared from './shared.js'

export default function () {
  startShared()

  document.addEventListener('DOMContentLoaded', () => {
    const marginTop = getComputedStyle(document.body).getPropertyValue('--body-margin-top').trim()
    const scrolledHeader = document.querySelector('#js__scrolledHeader')
    const observedEle = document.querySelector('#js__observed')

    new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            scrolledHeader.classList.remove('scrolled')
          } else {
            scrolledHeader.classList.add('scrolled')
          }
        })
      },
      {
        rootMargin: `-${marginTop} 0px 0px 0px`
      }
    ).observe(observedEle)
  })
}
